export default __webpack_public_path__ + "static/media/react-router.61be078e.svg";